import BaseComponent from '@/components/base/BaseComponent'
import HeaderBar from '@/components/dashboard/header/Header.component'
import IdleModalComponent from '@/components/dashboard/idle-modal/IdleModal.component'
import SideMenu from '@/components/dashboard/side-menu/SideMenu.component'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ReportModel} from '@/models/Report.model';
import {FileMimeType, KeyValuePair, Notification, ServiceApi, UserDetailsResponse, Utils} from '@payroll/optimus-common'
import $ from 'jquery'
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'

@Component({
  components: {
    HeaderBar,
    SideMenu,
    IdleModalComponent
  }
})
export default class DashboardComponent extends BaseComponent {

  @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse
  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
  @Action('getUserDetails', StoreNamespace.AUTHENTICATION) getUserDetails: any
  @Mutation('setUserDetails', StoreNamespace.AUTHENTICATION) setUserDetails: any

  @Action('getPortalTypes', StoreNamespace.SEARCH) getPortalTypes!: any;
  @Mutation('setPortalTypes', StoreNamespace.SEARCH) setPortalTypes!: any;
  @Getter('portalTypes', StoreNamespace.SEARCH) portalTypes!: KeyValuePair[];

  @Action('getUserTypes', StoreNamespace.SEARCH) getUserTypes!: any;
  @Mutation('setUserTypes', StoreNamespace.SEARCH) setUserTypes!: any;
  @Getter('userTypes', StoreNamespace.SEARCH) userTypes!: KeyValuePair[];

  private mobileMenuIsActive: boolean = false
  private showAlertMessage: boolean = false
  private showErrorAlertMessage: boolean = false
  private alertMessage: string = ''
  private alertErrorMessage: string = ''
  private alertIcon: string = ''
  private showReportModal: boolean = false;

  private statusTypes: KeyValuePair[] = []

  public reportRecord: ReportModel = {} as ReportModel;

  created() {
    $('body').addClass(this.mngCompanyName)
    if (process.env.VUE_APP_RECAPTCHA_SITE_KEY) {
      this.$recaptchaLoaded().then(() => this.$recaptchaInstance.hideBadge())
    }
  }

  mounted() {
    this.$root.$on('showAlertNotification', this.showAlertNotification)
    this.$root.$on('showErrorAlertNotification', this.showErrorAlertNotification)

    if (!this.userDetails.menus) {
      this.getUserDetails({requestorCallback: this})
    }
    if (this.portalTypes.length === 0) {
      this.getPortalTypes({requestorCallback: this})
    }
    if (this.userTypes.length === 0) {
      this.getUserTypes({requestorCallback: this})
    }

    this.statusTypes = [{
      value: 'true',
      description: this.$t('success').toString()
    }, {
      value: 'false',
      description: this.$t('fail').toString()
    }];
  }

  onSuccess(data?: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case 'getUserDetails':
        this.setUserDetails(data)
        break
      case 'getPortalTypes':
        this.setPortalTypes(data)
        break;
      case 'generateMemberEntriesReport':
        this.showReportModal = false
        Utils.downloadFile(data.fileData, data.fileName, FileMimeType.EXCEL)
        break;
      case 'getUserTypes':
        this.setUserTypes(data)
        break;
    }
  }

  toggleMobileMenu(): void {
    this.mobileMenuIsActive = !this.mobileMenuIsActive
  }

  showAlertNotification(notificationObj: Notification) {
    this.showAlertMessage = notificationObj.toShow
    if (!notificationObj.toShow) {
      this.alertMessage = ""
      this.alertIcon = ""
      return
    }
    this.alertMessage = notificationObj.message
    this.alertIcon = notificationObj.icon
    if (notificationObj.secondsToDisappear) {
      setTimeout(() => {
        this.showAlertMessage = false
      }, notificationObj.secondsToDisappear * 1000)
    }
  }

  showErrorAlertNotification(notificationObj: Notification) {
    this.showErrorAlertMessage = notificationObj.toShow

    if (!notificationObj.toShow) {
      this.alertErrorMessage = ""
      this.alertIcon = ""
      return
    }
    this.alertErrorMessage = notificationObj.message
    if (notificationObj.secondsToDisappear) {
      setTimeout(() => {
        this.showErrorAlertMessage = false
      }, notificationObj.secondsToDisappear * 1000)
    }
  }

  public closeModal(modalObj: any): void {
    let notificationObj: Notification;

    this.showReportModal = false

    if (modalObj.updateSent) {
      notificationObj = {
        toShow: true,
        message: "updating_impersonate",
        icon: "spinner",
      } as Notification
      this.$root.$emit('showAlertNotification', notificationObj)
    } else if (modalObj.updateSucceeded) {
      notificationObj = {
        toShow: true,
        message: "authorize_to_impersonate_succeeded",
        icon: "checkCircle",
        secondsToDisappear: 3
      } as Notification
      this.$root.$emit('showAlertNotification', notificationObj)
    }
  }

  public onReportClick(): any {
    if (this.reportRecord.statusType) {
      this.reportRecord.successFlag = this.reportRecord.statusType.value === 'true'
    }
    delete this.reportRecord.statusType
    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName('generateMemberEntriesReport')
      .setRequestBody(this.reportRecord)
      .post(this)
  }

}
